export function pickRandomColor() {
  const colors = ['#fcbd07', '#ea1e23', '#121212'];
  return colors[Math.floor(Math.random() * 3)];
}
